import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import headerBar from '../modules/headerBar';
import footer from '../modules/footer';
import redeem from '../modules/redeem';


class RedeemPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
  	return (
	    <div id="page-redeem">
      <Helmet>
        <title>鄧師傅功夫菜-集點換購</title>
        <meta name="description" content="飄香高雄35載，滷豬腳年銷售超越50座臺北101大樓高度! 馳名海內外，獲得媒體一致推薦。Chef Teng founded in 1984, Taiwan, is famous for signature stewed pork knuckles and has won awards and recognition from news media around the world." />
      </Helmet>
        <headerBar.container/>
        <div className="row TitleBox">
          <p className="col-auto mr-auto Title">集點換購</p>
          <p className="col-auto DirectionTitle">首頁 / 集點換購</p>
        </div>

        <redeem.container
          productId={this.props.match.params.productId}
        />

        <footer.container/>
	    </div>
	  )
  }
}

export default RedeemPageComponent;
